import React from 'react';
import '../styles/widget.css';

interface ChatBubbleProps {
  onClick: () => void;
  unreadCount?: number;
  position?: 'bottom-right' | 'bottom-left' | 'top-right' | 'top-left';
  primaryColor?: string;
}

export const ChatBubble: React.FC<ChatBubbleProps> = ({
  onClick,
  unreadCount = 0,
  position = 'bottom-right',
  primaryColor = '#007bff',
}) => {
  return (
    <button
      className={`securedevkit-chat-bubble ${position}`}
      onClick={onClick}
      style={{ backgroundColor: primaryColor }}
      aria-label="Open chat"
    >
      💬
      {unreadCount > 0 && (
        <span className="securedevkit-chat-badge">
          {unreadCount > 99 ? '99+' : unreadCount}
        </span>
      )}
    </button>
  );
};

